import React, { useState } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Loading } from 'components/Loading'
import EventsComponent from 'sharedComponents/EventsDetail'
import DashboardPage from 'internal-portal/sharedComponents/DashboardPage'
import { Box } from 'components/Layout'
import Button from 'components/Button'
import { Text } from 'components/Typography'
import { ConfirmationDialog } from 'components/Dialog'
import { useToaster } from 'utils/useToaster'
import { Event, useCloseEvent } from '@modmd/data'

interface RouterProps {
  eventId: string
}

type EventProps = RouteComponentProps<RouterProps>

export enum UrlSearchQuery {
  EMAIL_OR_NAME_LIKE = 'emailOrNameLike',
  PAGE = 'page',
  ORDER_BY = 'orderBy',
  DIRECTION = 'direction',
  EVENT_DAY_ID = 'eventDayId',
}

const EventDetail: React.VFC<EventProps> = ({ match }) => {
  const [isLoadingEventAttendee, setIsLoadingEventAttendee] = useState(true)
  const [isLoadingEventData, setIsLoadingEventData] = useState(true)
  const [eventData, setEventData] = useState<{
    data: Event
    refetch: () => void
    loading: boolean
  }>({ data: { event: null }, refetch: () => {}, loading: false })
  const [hasPermission, setHasPermission] = useState(false)
  const [dialogCloseEvent, setDialogCloseEvent] = useState(false)
  const { setToastMessage } = useToaster()
  const [closeEvent, { loading: isLoadingCloseEvent }] = useCloseEvent({
    onCompleted: () => {
      setToastMessage('Event closed successfully', 'success')
      setDialogCloseEvent(false)
      void eventData?.refetch()
    },
  })
  return (
    <DashboardPage
      Header={
        <Loading isLoading={isLoadingEventData && isLoadingEventAttendee} isEmpty>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            height="100%"
            p="1rem"
          >
            <Text>{eventData?.data?.event?.id}</Text>
            <Box display="grid" gridAutoFlow="column" gridGap="0.5rem">
              {!eventData?.data?.event?.finishedAt && hasPermission && (
                <Button
                  onClick={() => {
                    setDialogCloseEvent(true)
                  }}
                  isFetching={isLoadingCloseEvent}
                >
                  Close Event
                </Button>
              )}
            </Box>
          </Box>
        </Loading>
      }
    >
      <EventsComponent
        eventId={match.params.eventId}
        setIsLoadingEventAttendee={setIsLoadingEventAttendee}
        setIsLoadingEventData={setIsLoadingEventData}
        setEventData={setEventData}
        setHasPermission={setHasPermission}
      />
      {hasPermission && (
        <ConfirmationDialog
          title="Close event"
          isOpen={dialogCloseEvent}
          onDismiss={() => {
            setDialogCloseEvent(false)
          }}
          actions={
            <>
              <Button
                colorVariant="secondary"
                disabled={isLoadingCloseEvent}
                onClick={() => {
                  setDialogCloseEvent(false)
                }}
              >
                Cancel
              </Button>
              <Button
                colorVariant="danger"
                isFetching={isLoadingCloseEvent}
                onClick={() => {
                  void closeEvent({
                    variables: {
                      id: String(eventData?.data?.event?.id),
                    },
                  })
                }}
              >
                Close Event
              </Button>
            </>
          }
        >
          <Text>Are you sure you want to close this event?</Text>
        </ConfirmationDialog>
      )}
    </DashboardPage>
  )
}
export default EventDetail
